import MorseApp from './MorseApp'
import ErrorBoundary from './components/ErrorBoundary'

import CookieConsent from './components/CookieConsent'

function App() {
  return (
    <ErrorBoundary>
      <MorseApp />
      <CookieConsent onLearnMore={() => window.location.hash = '#/legal/privacy'} />
    </ErrorBoundary>
  )
}

export default App
